declare global {
    interface Window {
        __PITANGO_INLINE_ASSETS__?: Record<string, string>;
    }
}

export function assetUrl(path: string): string {
    const normalized = path.replace(/^\/+/, "");
    if (window.__PITANGO_INLINE_ASSETS__?.[normalized]) return window.__PITANGO_INLINE_ASSETS__[normalized];
    // Respect Vite's configured base (e.g. "/v2/" in production, see
    // vite.config.ts) so asset URLs resolve correctly when this app is
    // served from a sub-path alongside the v1 storefront.
    const base = import.meta.env.BASE_URL.replace(/\/+$/, "");
    return `${base}/assets/${normalized}`;
}

/** Fallback thumbnail used whenever a product/category has no real image. */
export const PLACEHOLDER_IMAGE_URL = assetUrl("images/pitango-logo.png");

/** True when `src` is our own placeholder logo rather than a real product/category photo. */
export function isPlaceholderImage(src: string | undefined | null): boolean {
    return src === PLACEHOLDER_IMAGE_URL;
}
